import { EntityList } from '@avangard/utils/entity';

import { ChatEntity } from './chat.entity';

import type { Entity } from './chat.entity';

class ChatEntityList extends EntityList<ChatEntity> {
    constructor(items: Entity[] | null, count?: number | null) {
        super(ChatEntity, items, count);
    }
}

export { ChatEntityList };
